const VehicleLookupModal = () => import(/* webpackChunkName: "vehicle-lookup-modal-chunk" */ './VehicleLookupModal.vue')

export { VehicleLookupModal }
